<template>
    <div class="prescription-insurance">
        <div :class="{'is-loading': loading}">
            <template v-if="showDetail">
                <a href="#" class="back-to-search" @click.prevent="backToSearch">
                    <span class="material-symbols-rounded">west</span>
                    <span class="text">Zurück zur Suche</span>
                </a>
                <strong class="headline-sm text-bold">{{ currentCompany.name }}</strong>
                <p v-if="currentCompany.note" class="text-default"><strong>Nachricht von {{ currentCompany.name }}:</strong> {{ currentCompany.note }}</p>
                <p class="text-default">Benötigen Sie Hilfe bei der Einreichung des Rezepts bei Ihrer Krankenversicherung? Dann <a href="/kontakt">kontaktieren Sie uns</a>.</p>

                <dl>
                    <template v-if="currentCompany.website">
                        <dt>Website</dt>
                        <dd><a :href="currentCompany.website" target="_blank" rel="noopener noreferrer">{{ currentCompany.website }}</a></dd>
                    </template>
                    <template v-if="currentCompany.appstore_android || currentCompany.appstore_ios">
                        <dt>App</dt>
                        <dd>
                            <a v-if="currentCompany.appstore_android" :href="currentCompany.appstore_android" target="_blank" rel="noopener noreferrer">Android</a> 
                            <template v-if="currentCompany.appstore_ios && currentCompany.appstore_android">or</template>
                            <a v-if="currentCompany.appstore_ios" :href="currentCompany.appstore_ios" target="_blank" rel="noopener noreferrer">iOS</a>
                        </dd>
                    </template>
                    <template v-if="currentCompany.post_address">
                        <dt>Post-Adresse</dt>
                        <dd>{{ currentCompany.post_address }}</dd>
                    </template>
                    <template v-if="currentCompany.url_contact_form">
                        <dt>Online form</dt>
                        <dd><a :href="currentCompany.url_contact_form" target="_blank" rel="noopener noreferrer">Hier klicken</a></dd>
                    </template>
                    <template v-if="currentCompany.email">
                        <dt>E-Mail</dt>
                        <dd><a :href="'mailto:'+currentCompany.email">{{ currentCompany.email }}</a></dd>
                    </template>
                    <template v-if="currentCompany.phone">
                        <dt>Telefon</dt>
                        <dd><a :href="'tel:'+currentCompany.phone">{{ currentCompany.phone }}</a> <span>(in dringenden Fällen)</span></dd>
                    </template>
                </dl>

                <p class="text-default"><strong>Informationen:</strong> Falls Sie das Rezept auf dem Postweg oder per E-Mail an die Krankenversicherung senden, verwenden Sie dazu bitte das folgende Musteranschreiben.</p>
            
                <ul class="no-list-style text-default">
                    <li>
                        <a :href="receptLink">
                            <span class="material-symbols-rounded">file_download</span>
                            <strong>Anschreiben zur Einreichung eines Rezepts</strong>
                        </a> (DOC)
                    </li>
                    <li>
                        <a :href="diagnoseLink">
                            <span class="material-symbols-rounded">file_download</span>
                            <strong>Anschreiben zur Einreichung eines Diagnosenachweises</strong>
                        </a> (DOC)
                    </li>
                </ul>
            </template>
            <template v-else>
                <div v-if="loading" class="loader-wrapper">
                    <img src="imgs/vitadio-loader.svg" alt="">
                </div>

                <p class="text-big text-bold">Wenden Sie sich direkt an Ihre Krankenversicherung</p>
                <p class="text-default">Einen Freischaltcode für die Vitadio-App erhalten Sie von Ihrer Krankenversicherung über alle gängigen Kommunikationskanäle - die Krankenkassen-App, das Webportal, per E-Mail, oder per Post. </p>
                <p class="text-default">Benötigen Sie Hilfe beim Einreichen des Rezepts oder des Diagnosenachweises bei Ihrer Krankenversicherung? Dann <a href="/kontakt">kontaktieren Sie uns</a>.</p>

                <div class="input-wrapper form-input-text input-has-full-border search-wrapper" @focusout="handleFocusOut">
                    <span class="material-symbols-rounded">search</span>
                    <input
                        class="full-border"
                        type="text"
                        placeholder="Krankenkasse suchen"
                        v-model="searchValue"
                        @click="isActive = true"
                    />

                    <div v-if="insuranceCompanies && isDropdownActive" class="insurance-companies-dropdown">
                        <ul class="no-list-style">
                            <li v-for="company in companiesArray" :key="company.id">
                                <a href="#" :data-id="company.id" @click.prevent="showCompanyDetail(company.id)">{{ company.name }}</a>
                            </li>

                            <li v-if="companiesArray.length === 0">
                                <span>Nichts gefunden</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </div>

        <div>
            <p class="text-default text-bold">Haben Sie eine PKV?</p>
            <p class="text-default">Fragen Sie Ihre private Krankenversicherung, ob und wie die Kosten für Vitadio erstattet werden können. <a href="/kontakt?pkv-self-payer">Kontaktieren Sie uns</a> für weitere Informationen.</p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                errors: {},
                showDetail: false,
                insuranceCompanies: null,
                currentCompany: {},
                searchValue: '',
                isActive: false,
                loading: false,
                receptLink: 'uploads/manual_uploads/Vitadio_Vorlage_Krankenkasse_Rezept.docx',
                diagnoseLink: 'uploads/manual_uploads/Vitadio_Vorlage_Krankenkasse_Diagnose.docx'
            }
        },
        mounted() {
            var that = this
            this.fetchCompanies()
        },
        computed: {
            companiesArray() {
                let filteredCompanies = _.orderBy(this.insuranceCompanies, ['name'], ['asc'])

                if (this.searchValue != '' && this.searchValue) {
                    filteredCompanies = filteredCompanies.filter((item) => {
                        if(item.name.toLowerCase().includes(this.searchValue.toLowerCase())) {
                            return item
                        }
                    })
                }
                
                return filteredCompanies
            },

            isDropdownActive() {
                if(this.searchValue != '' || (this.searchValue === '' && this.isActive)) {
                    return true
                }

                return false
            }
        },
        methods: {
            backToSearch() {
                this.showDetail = false
                this.isActive = false
                this.searchValue = ''
            },

            fetchCompanies() {
                axios
                    .get('api/de-insurers')
                    .then((e) => {
                        this.insuranceCompanies = e.data.data
                    })
                    .catch((e) => {
                        console.log(e.response)
                    })
            },

            showCompanyDetail(id) {
                this.loading = true

                axios
                    .get(`api/de-insurers/${id}`)
                    .then((e) => {
                        this.currentCompany = e.data.data
                        this.showDetail = true
                        this.loading = false
                    })
                    .catch((e) => {
                        console.log(e.response)
                    })
            },

            handleFocusOut(event) {
                if(this.searchValue === '' && !event.relatedTarget || (event.relatedTarget && !event.relatedTarget.dataset)) {
                    setTimeout(() => {
                        this.isActive = false
                    }, 150);
                }
            }
        }
    }
</script>
